<template>
	<div class="workplace">
		<a-card :bordered="false" class="workplace-stat-card">
			<a-row :gutter="24">
				<a-col :xs="24" :sm="12" :lg="6">
					<a-card :loading="loadingCurrent" :bordered="false" class="stat-card">
						<div class="stat-card-inner">
							<div class="stat-left">
								<div class="stat-title">当前</div>
								<div class="stat-main">{{ fmtNum(current.totalUser) }}</div>
							</div>
							<div class="stat-divider" />
							<div class="stat-right">
								<div>男: {{ fmtNum(current.maleUser) }}</div>
								<div>女: {{ fmtNum(current.femaleUser) }}</div>
							</div>
						</div>
					</a-card>
			</a-col>
			<a-col :xs="24" :sm="12" :lg="6">
				<a-card :loading="loadingYesterday" :bordered="false" class="stat-card">
					<div class="stat-card-inner">
						<div class="stat-left">
							<div class="stat-title">昨日</div>
							<div class="stat-main">{{ fmtNum(periodYesterday.total) }}</div>
						</div>
						<div class="stat-divider" />
						<div class="stat-right">
							<div>
								男: {{ fmtNum(periodYesterday.activeMale) }}
								<span v-if="periodYesterday.registerMale !== 0" :class="deltaClass(periodYesterday.registerMale)">
									{{ formatDelta(periodYesterday.registerMale) }}
								</span>
							</div>
							<div>
								女: {{ fmtNum(periodYesterday.activeFemale) }}
								<span v-if="periodYesterday.registerFemale !== 0" :class="deltaClass(periodYesterday.registerFemale)">
									{{ formatDelta(periodYesterday.registerFemale) }}
								</span>
							</div>
						</div>
					</div>
				</a-card>
			</a-col>
			<a-col :xs="24" :sm="12" :lg="6">
				<a-card :loading="loadingLast7" :bordered="false" class="stat-card">
					<div class="stat-card-inner">
						<div class="stat-left">
							<div class="stat-title">近7日</div>
							<div class="stat-main">{{ fmtNum(periodLast7.total) }}</div>
						</div>
						<div class="stat-divider" />
						<div class="stat-right">
							<div>
								男: {{ fmtNum(periodLast7.activeMale) }}
								<span v-if="periodLast7.registerMale !== 0" :class="deltaClass(periodLast7.registerMale)">
									{{ formatDelta(periodLast7.registerMale) }}
								</span>
							</div>
							<div>
								女: {{ fmtNum(periodLast7.activeFemale) }}
								<span v-if="periodLast7.registerFemale !== 0" :class="deltaClass(periodLast7.registerFemale)">
									{{ formatDelta(periodLast7.registerFemale) }}
								</span>
							</div>
						</div>
					</div>
				</a-card>
			</a-col>
			<a-col :xs="24" :sm="12" :lg="6">
				<a-card :loading="loadingMonth" :bordered="false" class="stat-card">
					<div class="stat-card-inner">
						<div class="stat-left">
							<div class="stat-title">本月</div>
							<div class="stat-main">{{ fmtNum(periodMonth.total) }}</div>
						</div>
						<div class="stat-divider" />
						<div class="stat-right">
							<div>
								男: {{ fmtNum(periodMonth.activeMale) }}
								<span v-if="periodMonth.registerMale !== 0" :class="deltaClass(periodMonth.registerMale)">
									{{ formatDelta(periodMonth.registerMale) }}
								</span>
							</div>
							<div>
								女: {{ fmtNum(periodMonth.activeFemale) }}
								<span v-if="periodMonth.registerFemale !== 0" :class="deltaClass(periodMonth.registerFemale)">
									{{ formatDelta(periodMonth.registerFemale) }}
								</span>
							</div>
						</div>
					</div>
				</a-card>
			</a-col>
			</a-row>
		</a-card>

		<a-card :bordered="false">
			<a-tabs :activeKey="mainTab" @change="onMainTabChange">
				<a-tab-pane key="user" tab="用户">
					<div class="chart-toolbar">
						<a-select v-model="chartUserFilter" style="width: 140px" @change="onChartFilterChange">
							<a-select-option value="ALL">全部用户</a-select-option>
							<a-select-option value="MALE">男用户</a-select-option>
							<a-select-option value="FEMALE">女用户</a-select-option>
						</a-select>
					</div>
					<div class="chart-body">
						<div class="chart-main">
							<a-spin :spinning="chartLoading">
								<div ref="userLineChartRef" class="chart-box" />
							</a-spin>
						</div>
						<div class="chart-side chart-side--pie">
							<div class="side-title">性别占比（全站）</div>
							<a-spin :spinning="chartLoading">
								<div ref="userPieChartRef" class="chart-pie" />
							</a-spin>
						</div>
					</div>
				</a-tab-pane>
				<a-tab-pane key="activity" tab="活跃度">
					<div class="chart-toolbar">
						<span class="toolbar-label">用户</span>
						<a-select v-model="chartUserFilter" style="width: 140px" @change="onChartFilterChange">
							<a-select-option value="ALL">全部用户</a-select-option>
							<a-select-option value="MALE">男用户</a-select-option>
							<a-select-option value="FEMALE">女用户</a-select-option>
						</a-select>
					</div>
					<div class="chart-body">
						<div class="chart-main">
							<a-spin :spinning="chartLoading">
								<div ref="activityChartRef" class="chart-box" />
							</a-spin>
						</div>
						<div class="chart-side">
							<div class="side-title">用户构成</div>
							<div class="side-total">用户总量 {{ fmtNum(activitySidebar.totalUser) }}</div>
							<div class="side-row">
								<span>用户</span>
								<a-progress :percent="100" :show-info="false" stroke-color="#fa8c16" />
							</div>
							<div class="side-row">
								<span>男用户</span>
								<a-progress :percent="activitySidebar.malePct" :show-info="true" stroke-color="#fa8c16" />
							</div>
							<div class="side-row">
								<span>女用户</span>
								<a-progress :percent="activitySidebar.femalePct" :show-info="true" stroke-color="#fa8c16" />
							</div>
						</div>
					</div>
				</a-tab-pane>
				<a-tab-pane key="conversation" tab="会话">
					<div class="chart-toolbar">
						<span class="toolbar-label">用户</span>
						<a-select v-model="chartUserFilter" style="width: 140px" @change="onChartFilterChange">
							<a-select-option value="ALL">全部用户</a-select-option>
							<a-select-option value="MALE">男用户</a-select-option>
							<a-select-option value="FEMALE">女用户</a-select-option>
						</a-select>
					</div>
					<div class="chart-body">
						<div class="chart-main">
							<a-spin :spinning="chartLoading">
								<div ref="conversationChartRef" class="chart-box" />
							</a-spin>
						</div>
						<div class="chart-side">
							<div class="side-title">用户构成</div>
							<div class="side-total">用户总量 {{ fmtNum(conversationSidebar.totalUser) }}</div>
							<div class="side-row">
								<span>用户</span>
								<a-progress :percent="100" :show-info="false" stroke-color="#fa8c16" />
							</div>
							<div class="side-row">
								<span>男用户</span>
								<a-progress :percent="conversationSidebar.malePct" :show-info="true" stroke-color="#fa8c16" />
							</div>
							<div class="side-row">
								<span>女用户</span>
								<a-progress :percent="conversationSidebar.femalePct" :show-info="true" stroke-color="#fa8c16" />
							</div>
						</div>
					</div>
				</a-tab-pane>
			</a-tabs>
		</a-card>
	</div>
</template>

<script>
import * as echarts from 'echarts';
import {
	workplaceCurrent,
	workplacePeriodSummary,
	workplaceActivityChart,
	workplaceConversationChart,
	workplaceUserPanelChart,
} from '@/api/workplace';

const emptyPeriod = () => ({
	total: 0,
	activeMale: 0,
	activeFemale: 0,
	registerMale: 0,
	registerFemale: 0,
});

const emptySidebar = () => ({
	totalUser: 0,
	maleUser: 0,
	femaleUser: 0,
	malePct: 0,
	femalePct: 0,
});

export default {
	data() {
		return {
			loadingCurrent: false,
			loadingYesterday: false,
			loadingLast7: false,
			loadingMonth: false,
			current: { totalUser: 0, maleUser: 0, femaleUser: 0 },
			periodYesterday: emptyPeriod(),
			periodLast7: emptyPeriod(),
			periodMonth: emptyPeriod(),
			mainTab: 'user',
			chartUserFilter: 'ALL',
			chartLoading: false,
			activitySidebar: emptySidebar(),
			conversationSidebar: emptySidebar(),
			userLineChart: null,
			userPieChart: null,
			activityChart: null,
			conversationChart: null,
			resizeHandler: null,
		};
	},
	created() {
		this.loadStatCards();
	},
	mounted() {
		this.resizeHandler = () => this.resizeCharts();
		window.addEventListener('resize', this.resizeHandler);
		this.$nextTick(() => {
			this.loadUserPanelChart();
		});
	},
	beforeDestroy() {
		if (this.resizeHandler) {
			window.removeEventListener('resize', this.resizeHandler);
		}
		this.disposeUserLineChart();
		this.disposeUserPieChart();
		this.disposeActivityChart();
		this.disposeConversationChart();
	},
	methods: {
		fmtNum(v) {
			if (v == null || v === '') return '0';
			return Number(v).toLocaleString();
		},
		formatDelta(n) {
			if (n > 0) return `+${n}`;
			return String(n);
		},
		deltaClass(n) {
			if (n > 0) return 'delta-up';
			if (n < 0) return 'delta-down';
			return '';
		},
		loadStatCards() {
			this.loadingCurrent = true;
			workplaceCurrent()
				.then((res) => {
					if (!res.isSucceed) {
						this.$message.error(res.message || '加载失败');
						return;
					}
					const d = res.data || {};
					this.current = {
						totalUser: d.totalUser || 0,
						maleUser: d.maleUser || 0,
						femaleUser: d.femaleUser || 0,
					};
				})
				.catch(() => this.$message.error('网络异常'))
				.finally(() => {
					this.loadingCurrent = false;
				});

			const loadPeriod = (period, key, loadingKey) => {
				this[loadingKey] = true;
				workplacePeriodSummary(period)
					.then((res) => {
						if (!res.isSucceed) {
							this.$message.error(res.message || '加载失败');
							return;
						}
						const d = res.data || {};
						this[key] = {
							total: d.total || 0,
							activeMale: d.activeMale || 0,
							activeFemale: d.activeFemale || 0,
							registerMale: d.registerMale || 0,
							registerFemale: d.registerFemale || 0,
						};
					})
					.catch(() => this.$message.error('网络异常'))
					.finally(() => {
						this[loadingKey] = false;
					});
			};
			loadPeriod('yesterday', 'periodYesterday', 'loadingYesterday');
			loadPeriod('last7', 'periodLast7', 'loadingLast7');
			loadPeriod('month', 'periodMonth', 'loadingMonth');
		},
		onMainTabChange(key) {
			this.mainTab = key;
			this.$nextTick(() => {
				if (key === 'user') {
					this.disposeActivityChart();
					this.disposeConversationChart();
					this.loadUserPanelChart();
				} else if (key === 'activity') {
					this.disposeUserLineChart();
					this.disposeUserPieChart();
					this.loadActivityChart();
				} else {
					this.disposeUserLineChart();
					this.disposeUserPieChart();
					this.loadConversationChart();
				}
			});
		},
		onChartFilterChange() {
			if (this.mainTab === 'user') {
				this.loadUserPanelChart();
			} else if (this.mainTab === 'activity') {
				this.loadActivityChart();
			} else {
				this.loadConversationChart();
			}
		},
		loadUserPanelChart() {
			this.chartLoading = true;
			workplaceUserPanelChart(this.chartUserFilter)
				.then((res) => {
					if (!res.isSucceed) {
						this.$message.error(res.message || '加载失败');
						return;
					}
					const data = res.data || {};
					this.$nextTick(() => {
						this.renderUserPanelLine(
							data.dateList || [],
							data.totalSeries || [],
							data.maleSeries || [],
							data.femaleSeries || [],
						);
						this.renderUserPanelPie(data.pieSeries || []);
					});
				})
				.catch(() => this.$message.error('网络异常'))
				.finally(() => {
					this.chartLoading = false;
				});
		},
		loadActivityChart() {
			this.chartLoading = true;
			workplaceActivityChart(this.chartUserFilter).then((res) => {
					if (!res.isSucceed) {
						this.$message.error(res.message || '加载失败');
						return;
					}
					const data = res.data || {};
					this.activitySidebar = { ...emptySidebar(), ...(data.sidebar || {}) };
					this.$nextTick(() => {
						this.renderActivityLine(data.dateList, data.activeSeries || [], data.totalSeries || []);
					});
				})
				.catch(() => this.$message.error('网络异常'))
				.finally(() => {
					this.chartLoading = false;
				});
		},
		loadConversationChart() {
			this.chartLoading = true;
			workplaceConversationChart({ userFilter: this.chartUserFilter, days: 14 })
				.then((res) => {
					if (!res.isSucceed) {
						this.$message.error(res.message || '加载失败');
						return;
					}
					const d = res.data || {};
					this.conversationSidebar = { ...emptySidebar(), ...(d.sidebar || {}) };
					this.$nextTick(() => {
						this.renderConversationBar(d.dates || [], d.series || []);
					});
				})
				.catch(() => this.$message.error('网络异常'))
				.finally(() => {
					this.chartLoading = false;
				});
		},
		disposeActivityChart() {
			if (this.activityChart) {
				this.activityChart.dispose();
				this.activityChart = null;
			}
		},
		disposeConversationChart() {
			if (this.conversationChart) {
				this.conversationChart.dispose();
				this.conversationChart = null;
			}
		},
		disposeUserLineChart() {
			if (this.userLineChart) {
				this.userLineChart.dispose();
				this.userLineChart = null;
			}
		},
		disposeUserPieChart() {
			if (this.userPieChart) {
				this.userPieChart.dispose();
				this.userPieChart = null;
			}
		},
        // 渲染用户面板折线图
		renderUserPanelLine(dateList, totalSeries, maleSeries, femaleSeries) {
			const el = this.$refs.userLineChartRef;
			if (!el) return;
			this.disposeUserLineChart();
			this.userLineChart = echarts.init(el);
			this.userLineChart.setOption({
				tooltip: { trigger: 'axis' },
				legend: { data: ['总用户', '男用户', '女用户'], bottom: 0 },
				grid: { left: 52, right: 32, top: 28, bottom: 56 },
				xAxis: { type: 'category', boundaryGap: false, data: dateList },
				yAxis: { type: 'value', name: '累计用户数', splitLine: { lineStyle: { type: 'dashed' } } },
				series: [
					{
						name: '总用户',
						type: 'line',
						smooth: true,
						data: totalSeries,
						itemStyle: { color: '#5470c6' },
					},
					{
						name: '男用户',
						type: 'line',
						smooth: true,
						data: maleSeries,
						itemStyle: { color: '#91cc75' },
					},
					{
						name: '女用户',
						type: 'line',
						smooth: true,
						data: femaleSeries,
						itemStyle: { color: '#fac858' },
					},
				],
			});
			setTimeout(() => this.userLineChart && this.userLineChart.resize(), 0);
		},
        // 渲染用户面板饼图
		renderUserPanelPie(pieSeries) {
			const el = this.$refs.userPieChartRef;
			if (!el) {
				return;
			}
			this.disposeUserPieChart();
			const normalized = (pieSeries || []).map((x) => ({
				name: x.name || '',
				value: Number(x.value) || 0,
			}));
			const chartData = normalized.filter((x) => x.value > 0);
			const finalData = chartData.length > 0 ? chartData : [{ name: '暂无', value: 1 }];
			this.userPieChart = echarts.init(el);
			this.userPieChart.setOption({
				tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)' },
				legend: {
					orient: 'horizontal',
					bottom: 8
				},
				series: [
					{
						name: '性别',
						type: 'pie',
						radius: ['20%', '55%'],
						center: ['50%', '50%'],
						avoidLabelOverlap: true,
						itemStyle: { borderColor: '#fff', borderWidth: 1 },
						label: {
							show: true,
							position: 'outside',
							formatter: '{b}\n{d}%',
							fontSize: 12,
						},
						labelLine: { length: 10, length2: 6, smooth: true },
						data: finalData,
						color: ['#5b8ff9', '#ff9f7f'],
					},
				],
			});
			setTimeout(() => this.userPieChart && this.userPieChart.resize(), 0);
		},
		renderActivityLine(dates, activeSeries, totalSeries) {
			const el = this.$refs.activityChartRef;
			if (!el) return;
			this.disposeActivityChart();
			this.activityChart = echarts.init(el);
			this.activityChart.setOption({
				tooltip: { trigger: 'axis' },
				legend: { data: ['活跃用户', '总用户'], bottom: 0 },
				grid: { left: 48, right: 48, top: 24, bottom: 56 },
				xAxis: { type: 'category', boundaryGap: false, data: dates },
				yAxis: [
					{ type: 'value', name: '活跃用户', splitLine: { lineStyle: { type: 'dashed' } } },
					{ type: 'value', name: '总用户', splitLine: { show: false } },
				],
				series: [
					{
						name: '活跃用户',
						type: 'line',
						smooth: true,
						data: activeSeries,
						itemStyle: { color: '#1890ff' },
					},
					{
						name: '总用户',
						type: 'line',
						smooth: true,
						yAxisIndex: 1,
						data: totalSeries,
						itemStyle: { color: '#52c41a' },
					},
				],
			});
			setTimeout(() => this.activityChart && this.activityChart.resize(), 0);
		},
		renderConversationBar(dates, series) {
			const el = this.$refs.conversationChartRef;
			if (!el) return;
			this.disposeConversationChart();
			this.conversationChart = echarts.init(el);
			this.conversationChart.setOption({
				tooltip: { trigger: 'axis' },
				legend: { data: ['会话'], bottom: 0 },
				grid: { left: 48, right: 24, top: 24, bottom: 56 },
				xAxis: { type: 'category', data: dates },
				yAxis: { type: 'value', splitLine: { lineStyle: { type: 'dashed' } } },
				series: [
					{
						name: '会话',
						type: 'bar',
						data: series,
						itemStyle: { color: '#fa8c16' },
						barMaxWidth: 36,
					},
				],
			});
			setTimeout(() => this.conversationChart && this.conversationChart.resize(), 0);
		},
		resizeCharts() {
			if (this.userLineChart) this.userLineChart.resize();
			if (this.userPieChart) this.userPieChart.resize();
			if (this.activityChart) this.activityChart.resize();
			if (this.conversationChart) this.conversationChart.resize();
		},
	},
};
</script>

<style lang="less" scoped>
.workplace {
	padding: 8px 16px 0 16px;
}

.workplace-stat-card {
	margin-bottom: 8px;
}

.workplace-stat-card /deep/ .stat-card {
	box-shadow: none;
	border: 1px solid #f0f0f0;
	height: 100%;

	.ant-card-body {
		padding: 16px 18px;
		height: 100%;
		box-sizing: border-box;
	}
}

/deep/ .stat-card-inner {
	display: flex;
	height: 100%;
}

.stat-left {
	flex: 1;
	min-width: 0;
}

.stat-title {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.45);
	margin-bottom: 8px;
}

.stat-main {
	font-size: 28px;
	font-weight: 600;
	color: rgba(0, 0, 0, 0.88);
	line-height: 1.2;
}

.stat-divider {
	width: 1px;
	background: #f0f0f0;
	margin: 0 16px;
	flex-shrink: 0;
}

.stat-right {
	flex: 1;
	font-size: 13px;
	color: rgba(0, 0, 0, 0.65);
	line-height: 1.8;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.delta-up {
	color: #52c41a;
	margin-left: 4px;
	font-weight: 500;
}

.delta-down {
	color: #ff4d4f;
	margin-left: 4px;
	font-weight: 500;
}

.chart-toolbar {
	margin-bottom: 12px;
	display: flex;
	align-items: center;
	gap: 8px;
}

.toolbar-label {
	color: rgba(0, 0, 0, 0.65);
	font-size: 14px;
}

.chart-body {
	display: flex;
	gap: 24px;
	align-items: stretch;
	flex-wrap: wrap;
    margin-top: 26px;
}

.chart-main {
	flex: 1 1 300px;
	min-width: 240px;
}

.chart-side {
	flex: 0 0 260px;
	max-width: 100%;
	padding: 8px 0 0;
	border-left: 1px solid #f0f0f0;
	padding-left: 20px;
}

/* 用户板块：饼图区加宽，避免图例/扇区标签被裁切 */
.chart-side.chart-side--pie {
	flex: 0 0 400px;
	min-width: 340px;
	max-width: 480px;
	width: 400px;
	box-sizing: border-box;
}

@media (max-width: 1200px) {
	.chart-side.chart-side--pie {
		flex: 1 1 100%;
		width: 100%;
		max-width: none;
		min-width: 0;
		border-left: none;
		padding-left: 0;
		border-top: 1px solid #f0f0f0;
		padding-top: 16px;
	}
}

@media (max-width: 992px) {
	.chart-side {
		flex: 1 1 100%;
		border-left: none;
		padding-left: 0;
		border-top: 1px solid #f0f0f0;
		padding-top: 16px;
	}

	.chart-side.chart-side--pie {
		flex: 1 1 100%;
		width: 100%;
		max-width: none;
		min-width: 0;
	}
}

.side-title {
	font-weight: 600;
	margin-bottom: 12px;
	color: rgba(0, 0, 0, 0.85);
}

.side-total {
	font-size: 13px;
	color: rgba(0, 0, 0, 0.55);
	margin-bottom: 16px;
}

.side-row {
	margin-bottom: 14px;
	span {
		display: block;
		font-size: 12px;
		color: rgba(0, 0, 0, 0.45);
		margin-bottom: 4px;
	}
}

.chart-box {
	width: 100%;
	height: 360px;
}

.chart-side--pie {
	display: flex;
	flex-direction: column;
}

.chart-pie {
	width: 100%;
	min-width: 300px;
	height: 400px;
	min-height: 320px;
}
</style>
